var map = {
	"./en_69.mp3": 58087,
	"./en_bingolady.mp3": 81914,
	"./en_happyholidays.mp3": 48742,
	"./en_onetogo.mp3": 77268,
	"./en_shuffle.mp3": 6534,
	"./es_15.mp3": 39671,
	"./es_22.mp3": 32338,
	"./es_4.mp3": 31182,
	"./es_69.mp3": 88922,
	"./es_9.mp3": 72558,
	"./es_happyholidays.mp3": 61352,
	"./es_lotengo.mp3": 9256,
	"./es_mezcla.mp3": 11297,
	"./it_46.mp3": 11197,
	"./it_48.mp3": 56660,
	"./it_69.mp3": 70337,
	"./it_77.mp3": 90075,
	"./it_90.mp3": 238,
	"./it_ambo.mp3": 38960,
	"./it_celho.mp3": 38537,
	"./it_happyholidays.mp3": 3059,
	"./it_mischia.mp3": 54015,
	"./it_onetogo.mp3": 90509,
	"./scam.mp3": 37523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25225;